import { lazy, Suspense } from 'react';
import { App as AntdApp, ConfigProvider } from 'antd';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ArtScrollManager from './components/ArtScrollManager';
import Layout from './components/Layout';
import AboutPage from './pages/AboutPage';
import ArtIndexPage from './pages/ArtIndexPage';
import ContactPage from './pages/ContactPage';
import FittingPage from './pages/FittingPage';
import HomePage from './pages/HomePage';
import ProjectPage from './pages/ProjectPage';

const FashionPage = lazy(() => import('./pages/FashionPage'));
const FashionLookPage = lazy(() => import('./pages/FashionLookPage'));
const WritingPage = lazy(() => import('./pages/WritingPage'));

export default function App({ basename }) {
  return (
    // ConfigProvider 统一 Ant Design 的主题 token，避免 UI 组件默认圆角/主色破坏原站极简视觉。
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#0a0a0a',
          borderRadius: 0,
          fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif"
        }
      }}
    >
      {/* AntdApp 提供 message、modal、notification 的上下文能力。 */}
      <AntdApp>
        {/* basename 用于兼容独立部署和 qiankun 主应用挂载路径。 */}
        <BrowserRouter basename={basename}>
          <ArtScrollManager />
          <Suspense fallback={null}>
            <Routes>
              {/* Layout 放公共 Header/Footer；具体页面通过 Outlet 渲染。 */}
              <Route element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="fashion" element={<FashionPage />} />
                <Route path="fashion/:showName/:lookIndex" element={<FashionLookPage />} />
                <Route path="fitting" element={<FittingPage />} />
                <Route path="art" element={<ArtIndexPage />} />
                {/* Art 详情页通过 slug 从 src/data/projects.js 中取对应项目数据。 */}
                <Route path="art/:slug" element={<ProjectPage />} />
                <Route path="writing" element={<WritingPage />} />
                <Route path="about" element={<AboutPage />} />
                <Route path="contact" element={<ContactPage />} />
                {/* 未匹配路由回首页，避免刷新旧路径时出现空白页面。 */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AntdApp>
    </ConfigProvider>
  );
}
